import { boxShadows } from '@eversports/design-tokens/box-shadows'
import Box from '@eversports/klimt-primitives/legacy/Box'
import * as React from 'react'

const BottomFixedSection = ({ children }: React.PropsWithChildren<unknown>) => {
  return (
    <Box
      sx={{
        p: 4,
        zIndex: 2,
        bottom: 0,
        backgroundColor: 'white',
        position: 'fixed',
        width: '100%',
        border: '1px solid',
        borderColor: 'lightgray',
        boxShadow: boxShadows.default,
        display: { xs: 'flex', lg: 'none' },
      }}
    >
      {children}
    </Box>
  )
}

export default BottomFixedSection
